"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentManagerProvider = exports.EnvironmentManagerContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _useAudiencePickerProvider = require("../AudiencePicker/provider/useAudiencePickerProvider");
var _ScoreTypes = require("./types/ScoreTypes");
var _EnvironmentManager = require("./EnvironmentManager.labels");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var EnvironmentManagerContext = /*#__PURE__*/_react.default.createContext({});
exports.EnvironmentManagerContext = EnvironmentManagerContext;
var EnvironmentManagerProvider = function EnvironmentManagerProvider(_ref) {
  var _userSessionData$user, _environmentProductIn;
  var children = _ref.children;
  // Hooks
  var getLabel = (0, _hooks.useLabels)({
    labels: _EnvironmentManager.labels
  });
  var userSessionData = (0, _hooks.useSessionData)();
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;

  // UI states
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    sliderView = _useState2[0],
    setSliderView = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    preloaderMode = _useState4[0],
    setPreloaderMode = _useState4[1];

  // API Data states
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    schoolYear = _useState6[0],
    setSchoolYear = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    schoolTeachers = _useState8[0],
    setSchoolTeachers = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    userGroups = _useState10[0],
    setUserGroups = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    userEnvironments = _useState12[0],
    setUserEnvironments = _useState12[1];

  // EnvironmentData states
  var _useState13 = (0, _react.useState)(),
    _useState14 = _slicedToArray(_useState13, 2),
    environmentIds = _useState14[0],
    setEnvironmentIds = _useState14[1];
  var _useState15 = (0, _react.useState)(''),
    _useState16 = _slicedToArray(_useState15, 2),
    environmentTitle = _useState16[0],
    setEnvironmentTitle = _useState16[1];
  var _useState17 = (0, _react.useState)(),
    _useState18 = _slicedToArray(_useState17, 2),
    environmentSchoolId = _useState18[0],
    setEnvironmentSchoolId = _useState18[1];
  var _useState19 = (0, _react.useState)(),
    _useState20 = _slicedToArray(_useState19, 2),
    environmentDates = _useState20[0],
    setEnvironmentDates = _useState20[1];
  var _useState21 = (0, _react.useState)(),
    _useState22 = _slicedToArray(_useState21, 2),
    environmentProductInfo = _useState22[0],
    setEnvironmentProductInfo = _useState22[1];
  var _useState23 = (0, _react.useState)([]),
    _useState24 = _slicedToArray(_useState23, 2),
    environmentTeachers = _useState24[0],
    setEnvironmentTeachers = _useState24[1];
  var _useState25 = (0, _react.useState)(),
    _useState26 = _slicedToArray(_useState25, 2),
    environmentAudience = _useState26[0],
    setEnvironmentAudience = _useState26[1];
  var _useState27 = (0, _react.useState)(false),
    _useState28 = _slicedToArray(_useState27, 2),
    isReadOnlyEnvironment = _useState28[0],
    setIsReadOnlyEnvironment = _useState28[1];
  var _useState29 = (0, _react.useState)([]),
    _useState30 = _slicedToArray(_useState29, 2),
    defaultEnvironmentTeachers = _useState30[0],
    setDefaultEnvironmentTeachers = _useState30[1];
  var _useState31 = (0, _react.useState)(),
    _useState32 = _slicedToArray(_useState31, 2),
    srcEnvironmentId = _useState32[0],
    setSrcEnvironmentId = _useState32[1];
  var teacherIds = (0, _react.useMemo)(function () {
    return environmentTeachers.map(function (t) {
      return t.UserID;
    });
  }, [environmentTeachers]);
  var currentEnvironmentAudience = (0, _react.useMemo)(function () {
    var _environmentAudience$, _environmentAudience$2, _environmentAudience$3;
    return {
      selectedGroups: (_environmentAudience$ = environmentAudience === null || environmentAudience === void 0 ? void 0 : (_environmentAudience$2 = environmentAudience.Groups) === null || _environmentAudience$2 === void 0 ? void 0 : _environmentAudience$2.map(function (g) {
        var groupData = userGroups.find(function (userGroup) {
          return userGroup.id === g;
        });
        return groupData;
      }).filter(Boolean)) !== null && _environmentAudience$ !== void 0 ? _environmentAudience$ : [],
      selectedStudents: (_environmentAudience$3 = environmentAudience === null || environmentAudience === void 0 ? void 0 : environmentAudience.SingleStudents) !== null && _environmentAudience$3 !== void 0 ? _environmentAudience$3 : []
    };
  }, [environmentAudience === null || environmentAudience === void 0 ? void 0 : environmentAudience.Groups, environmentAudience === null || environmentAudience === void 0 ? void 0 : environmentAudience.SingleStudents, userGroups]);
  var audiencePickerProvider = (0, _useAudiencePickerProvider.useAudiencePickerProvider)(_objectSpread(_objectSpread({}, currentEnvironmentAudience), {}, {
    schoolId: environmentSchoolId !== null && environmentSchoolId !== void 0 ? environmentSchoolId : undefined,
    teacherIds: teacherIds,
    isReadOnly: isReadOnlyEnvironment || teacherIds.length <= 0,
    fullHeight: "calc(100vh - ".concat(pxToRem(62), ")")
  }));
  var normalizeDate = function normalizeDate(date, format) {
    var normalizedDate = date ? new Date(date) : new Date();
    if (format === 'EndOfDay') {
      normalizedDate.setHours(23, 59, 59);
    } else {
      normalizedDate.setHours(0, 0, 0, 0);
    }
    return normalizedDate;
  };
  var resetEnvironment = function resetEnvironment() {
    setEnvironmentIds({
      Id: '',
      AudienceID: ''
    });
    setEnvironmentTitle('');
    setEnvironmentTeachers(defaultEnvironmentTeachers);
    setEnvironmentDates({
      Start: new Date(),
      End: schoolYear !== null && schoolYear !== void 0 && schoolYear.endDate ? new Date(schoolYear.endDate) : new Date()
    });
    setEnvironmentAudience({
      Groups: [],
      SingleStudents: []
    });
    setIsReadOnlyEnvironment(false);
  };
  (0, _react.useEffect)(function () {
    if (userSessionData.role === 'admin') {
      setSliderView('schoolSelector');
    } else {
      setSliderView('main');
    }
  }, [userSessionData.role]);
  (0, _react.useEffect)(function () {
    if (audiencePickerProvider.view === 'createGroup') {
      setSliderView('createGroup');
    } else if (audiencePickerProvider.view === 'studentsSelector') {
      setSliderView('studentsSelector');
    } else if (audiencePickerProvider.view === 'groupEdit') {
      setSliderView('groupEdit');
    } else if (audiencePickerProvider.view === 'inline') {
      setSliderView('main');
    }
  }, [audiencePickerProvider.view, setSliderView]);
  (0, _react.useEffect)(function () {
    if (userSessionData.role === 'teacher' && userSessionData.userId && userSessionData.displayName) {
      setDefaultEnvironmentTeachers([{
        UserName: userSessionData.displayName,
        UserID: userSessionData.userId
      }]);
    }
  }, [userSessionData.role, userSessionData.userId, userSessionData.displayName]);
  var environmentStartDate = (0, _react.useMemo)(function () {
    return normalizeDate(environmentDates === null || environmentDates === void 0 ? void 0 : environmentDates.Start, 'StartOfDay');
  }, [environmentDates === null || environmentDates === void 0 ? void 0 : environmentDates.Start]);
  var environmentEndDate = (0, _react.useMemo)(function () {
    return normalizeDate(environmentDates === null || environmentDates === void 0 ? void 0 : environmentDates.End, 'EndOfDay');
  }, [environmentDates === null || environmentDates === void 0 ? void 0 : environmentDates.End]);
  var environmentGroups = (0, _react.useMemo)(function () {
    return [].concat(_toConsumableArray(audiencePickerProvider === null || audiencePickerProvider === void 0 ? void 0 : audiencePickerProvider.selectedClassesIds), _toConsumableArray(audiencePickerProvider === null || audiencePickerProvider === void 0 ? void 0 : audiencePickerProvider.selectedGroupsIds)).filter(function (g) {
      return g;
    });
  }, [audiencePickerProvider === null || audiencePickerProvider === void 0 ? void 0 : audiencePickerProvider.selectedClassesIds, audiencePickerProvider === null || audiencePickerProvider === void 0 ? void 0 : audiencePickerProvider.selectedGroupsIds]);
  var environmentSingleStudents = (0, _react.useMemo)(function () {
    var _audiencePickerProvid, _audiencePickerProvid2;
    return (_audiencePickerProvid = audiencePickerProvider === null || audiencePickerProvider === void 0 ? void 0 : (_audiencePickerProvid2 = audiencePickerProvider.selectedStudentsIds) === null || _audiencePickerProvid2 === void 0 ? void 0 : _audiencePickerProvid2.map(function (studentId) {
      var _audiencePickerProvid3, _studentInfo$student$, _studentInfo$student, _studentInfo$classIds, _studentInfo$groupIds;
      var studentInfo = audiencePickerProvider === null || audiencePickerProvider === void 0 ? void 0 : (_audiencePickerProvid3 = audiencePickerProvider.studentsMapper) === null || _audiencePickerProvid3 === void 0 ? void 0 : _audiencePickerProvid3[studentId];
      return {
        id: studentId !== null && studentId !== void 0 ? studentId : '',
        fullName: (_studentInfo$student$ = studentInfo === null || studentInfo === void 0 ? void 0 : (_studentInfo$student = studentInfo.student) === null || _studentInfo$student === void 0 ? void 0 : _studentInfo$student.fullName) !== null && _studentInfo$student$ !== void 0 ? _studentInfo$student$ : '',
        UserID: studentId !== null && studentId !== void 0 ? studentId : '',
        ContextGroupID: studentInfo !== null && studentInfo !== void 0 && (_studentInfo$classIds = studentInfo.classIds) !== null && _studentInfo$classIds !== void 0 && _studentInfo$classIds.length ? studentInfo === null || studentInfo === void 0 ? void 0 : studentInfo.classIds[0] : studentInfo !== null && studentInfo !== void 0 && (_studentInfo$groupIds = studentInfo.groupIds) !== null && _studentInfo$groupIds !== void 0 && _studentInfo$groupIds.length ? studentInfo === null || studentInfo === void 0 ? void 0 : studentInfo.groupIds[0] : null
      };
    })) !== null && _audiencePickerProvid !== void 0 ? _audiencePickerProvid : [];
  }, [audiencePickerProvider === null || audiencePickerProvider === void 0 ? void 0 : audiencePickerProvider.selectedStudentsIds, audiencePickerProvider === null || audiencePickerProvider === void 0 ? void 0 : audiencePickerProvider.studentsMapper]);
  var value = {
    userSessionData: userSessionData,
    audiencePickerProvider: audiencePickerProvider,
    getLabel: getLabel,
    // UI Data
    sliderView: sliderView,
    setSliderView: setSliderView,
    preloaderMode: preloaderMode,
    setPreloaderMode: setPreloaderMode,
    // API Data
    schoolYear: schoolYear,
    setSchoolYear: setSchoolYear,
    schoolTeachers: schoolTeachers,
    setSchoolTeachers: setSchoolTeachers,
    userGroups: userGroups,
    setUserGroups: setUserGroups,
    userEnvironments: userEnvironments,
    setUserEnvironments: setUserEnvironments,
    // Environment Data
    resetEnvironment: resetEnvironment,
    setSrcEnvironmentId: setSrcEnvironmentId,
    setEnvironmentIds: setEnvironmentIds,
    setEnvironmentTitle: setEnvironmentTitle,
    setEnvironmentSchoolId: setEnvironmentSchoolId,
    setEnvironmentDates: setEnvironmentDates,
    setEnvironmentProductInfo: setEnvironmentProductInfo,
    setEnvironmentTeachers: setEnvironmentTeachers,
    setEnvironmentAudience: setEnvironmentAudience,
    setIsReadOnlyEnvironment: setIsReadOnlyEnvironment,
    defaultEnvironmentTeachers: defaultEnvironmentTeachers,
    srcEnvironmentId: srcEnvironmentId,
    environmentData: {
      Ids: environmentIds !== null && environmentIds !== void 0 ? environmentIds : {
        Id: '',
        AudienceID: ''
      },
      ProductInfo: environmentProductInfo !== null && environmentProductInfo !== void 0 ? environmentProductInfo : {},
      Title: environmentTitle,
      Dates: {
        Start: environmentStartDate,
        End: environmentEndDate
      },
      OwnerId: (_userSessionData$user = userSessionData.userId) !== null && _userSessionData$user !== void 0 ? _userSessionData$user : '',
      SchoolID: environmentSchoolId !== null && environmentSchoolId !== void 0 ? environmentSchoolId : '',
      Teachers: environmentTeachers,
      Audience: {
        Groups: environmentGroups,
        SingleStudents: environmentSingleStudents
      },
      ScoreType: (_environmentProductIn = environmentProductInfo === null || environmentProductInfo === void 0 ? void 0 : environmentProductInfo.defaultScoreType) !== null && _environmentProductIn !== void 0 ? _environmentProductIn : _ScoreTypes.ScoreTypes.Number,
      IsArchive: isReadOnlyEnvironment
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(EnvironmentManagerContext.Provider, {
    value: value,
    children: children
  });
};
exports.EnvironmentManagerProvider = EnvironmentManagerProvider;